var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[_c('div',{staticClass:"popup-bg"}),_c('div',{staticClass:"content"},[_c('div',{staticClass:"detail",domProps:{"innerHTML":_vm._s(_vm.detail)}}),_c('em',{staticClass:"close j-back",on:{"click":_vm.close}})])])}
var staticRenderFns = []

export { render, staticRenderFns }